import type { SearchModalTabId } from './search-modal.type'

export const SEARCH_DEBOUNCE_MS = 400

export const SEARCH_MIN_QUERY_LENGTH = 3

export const SEARCH_MODAL_PREVIEW_PER_CATEGORY_LIMIT = 5

export const COMMON_MESSAGES = {
  noMatches: 'No matches.',
  queryTooShort: (minLength: number) => `Type at least ${String(minLength)} characters to search.`,
  typeToSearch: 'Type to search Academy content.',
} as const

export const SEARCH_MODAL_FILTER_CHIP_IDS = {
  all: 'all',
  quickStart: 'quick-start',
  documents: 'documents',
  glossary: 'glossary',
  codeSamples: 'code-samples',
  courses: 'courses',
  videos: 'videos',
  forum: 'forum',
  events: 'events',
} as const

export const searchModalFilterChips: readonly {
  id: (typeof SEARCH_MODAL_FILTER_CHIP_IDS)[keyof typeof SEARCH_MODAL_FILTER_CHIP_IDS]
  label: string
  disabled?: boolean
}[] = [
  { id: SEARCH_MODAL_FILTER_CHIP_IDS.all, label: 'All' },
  { id: SEARCH_MODAL_FILTER_CHIP_IDS.quickStart, label: 'Quick start' },
  { id: SEARCH_MODAL_FILTER_CHIP_IDS.documents, label: 'Documents' },
  { id: SEARCH_MODAL_FILTER_CHIP_IDS.glossary, label: 'Glossary' },
  {
    id: SEARCH_MODAL_FILTER_CHIP_IDS.codeSamples,
    label: 'Code samples',
    disabled: true,
  },
  { id: SEARCH_MODAL_FILTER_CHIP_IDS.courses, label: 'Courses', disabled: true },
  { id: SEARCH_MODAL_FILTER_CHIP_IDS.videos, label: 'Videos', disabled: true },
  { id: SEARCH_MODAL_FILTER_CHIP_IDS.forum, label: 'Forum', disabled: true },
  { id: SEARCH_MODAL_FILTER_CHIP_IDS.events, label: 'Events', disabled: true },
]

export const searchModalTabs: readonly { id: SearchModalTabId; label: string; disabled?: boolean }[] = [
  { id: 'all', label: 'All', disabled: true },
  { id: 'services', label: 'Services', disabled: true },
  { id: 'grafts', label: 'Grafts', disabled: true },
  { id: 'modules', label: 'Modules', disabled: true },
  { id: 'gateways', label: 'Gateways', disabled: true },
  { id: 'academy', label: 'Academy' },
]
